export enum NavbarTypes {
  SET_TITLE = `@navbar/SET_TITLE`,
  TOGGLE_HOME_BTN = `@navbar/TOGGLE_HOME_BTN`,
  TOGGLE_BACK_NAVIGATION_BTN = `@navbar/TOGGLE_BACK_NAVIGATION_BTN`,
  TOGGLE_EXIT_BS = `@navbar/TOGGLE_EXIT_BS`,
  SET_DIRECTION = `@navbar/SET_DIRECTION`,
  SET_BACK_NAVIGATION_HANDLER = `@navbar/SET_BACK_NAVIGATION_HANDLER`,
  SET_HOME_NAVIGATION_HANDLER = `@navbar/SET_HOME_NAVIGATION_HANDLER`,
}

export interface NavbarState {
  readonly title: string
  readonly toggleHomeBtn: boolean
  readonly toggleBackNavigationBtn: boolean
  readonly toggleExitBS: boolean
  readonly direction: string

  readonly backNavigationHandler: () => void
  readonly homeNavigationHandler: () => void
}
